<script setup lang="ts">
// "Are you sure?" as a sheet, naming what will happen. Cancel and the confirm button
// sit in the sheet's head, the confirm last; `danger` makes it red. Emits `confirm`
// or `cancel`.
import Button from './Button.vue';
import Modal from './Modal.vue';

withDefaults(defineProps<{ open: boolean; title: string; confirmLabel?: string; danger?: boolean; busy?: boolean }>(), { confirmLabel: 'Confirm', danger: false, busy: false });
const emit = defineEmits<{ confirm: []; cancel: [] }>();
</script>

<template>
  <Modal :open="open" :title="title" @close="emit('cancel')">
    <slot />
    <template #actions>
      <Button variant="ghost" :disabled="busy" @click="emit('cancel')">Cancel</Button>
      <Button :variant="danger ? 'danger' : 'primary'" :disabled="busy" @click="emit('confirm')">{{ confirmLabel }}</Button>
    </template>
  </Modal>
</template>
